import { Box } from '@mantine/core';
import { observer } from 'mobx-react-lite';
import { PIITableV2 } from './PIITableV2';

export const DataSettings = observer(() => (
	<Box>
		<PIITableV2 />
	</Box>
));
